import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-section-about',
  templateUrl: './section-about.component.html',
  styleUrls: ['./section-about.component.scss']
})
export class SectionAboutComponent implements OnInit {
    @ViewChild('aboutSection', { static: true }) aboutSection!: ElementRef;

    observer!: IntersectionObserver;

    ngOnInit(): void {
        this.setupScrollAnimation();
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }

    setupScrollAnimation() {
        this.observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('fade-up-active');
            }
        }, { threshold: 0.2 });

        this.observer.observe(this.aboutSection.nativeElement);
    }
    leftImages = [
        { filename: '1.png', type: "Casa en anticretico", city: "Sucre" },
        { filename: '2.png', type: "Departamento en venta", city: "Santa Cruz" },
        { filename: '3.png', type: "Casa en anticretico", city: "Sucre" },
        { filename: '1.png', type: "Departamento en venta", city: "Santa Cruz" },
    ];

    rightImages = [
        { filename: '4.png', type: "Casa en anticretico", city: "Sucre" },
        { filename: '5.png', type: "Departamento en venta", city: "Santa Cruz" },
        { filename: '6.png', type: "Casa en anticretico", city: "Sucre" },
        { filename: '4.png', type: "Departamento en venta", city: "Santa Cruz" },
    ];

}
